import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Close from "@material-ui/icons/Close";
import { withStyles } from "@material-ui/core/styles";
import { DialogStyles } from "./styles";
import { Dialog as MUIDialog } from "@material-ui/core";
import logo from "../../images/Logo.svg";

const Dialog = withStyles(DialogStyles)(
  ({
    children,
    displayDensity,
    classes,
    label,
    title,
    open,
    onClose,
    noClose,
    ...props
  }) => (
    <MUIDialog
      open={open}
      onClose={onClose}
      aria-labelledby={label}
      disableBackdropClick={noClose}
      classes={{
        paper: classes.paper
      }}
      className={classNames({
        [classes[displayDensity]]: displayDensity !== "default"
      })}
      {...props}
    >
      <div className={classes.header}>
        {!!title && <h3>{title}</h3>}
        <img src={logo} alt="Mondaybee Logo" className={classes.logo} />
      </div>
      {children}
      {!noClose && <Close className={classes.closeBtn} onClick={onClose} />}
    </MUIDialog>
  )
);

Dialog.defaultProps = {
  displayDensity: "default",
  size: "md"
};

Dialog.propTypes = {
  children: PropTypes.element,
  displayDensity: PropTypes.oneOf(["default", "compact"]),
  size: PropTypes.oneOf(["md", "lg"]),
  label: PropTypes.string,
  title: PropTypes.string,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  noClose: PropTypes.bool
};

export default Dialog;



// WEBPACK FOOTER //
// ./src/components/Dialogs/Dialog.js